<spark-layout>
  <layout-content>

    <ng-container *appLoad="let tasks of consolidatedTasks$">
      <div class="tasks">
        <!-- header -->
        <div class="tasks__header">
          <div class="row">
            <div class="col align-self-center">
              <h2 class="m-none">Tasks</h2>
            </div>
          </div>
        </div>

        <!-- filters -->
        <div class="tasks__filters">
          <form [formGroup]="form">
            <div class="row align-items-center">
              <!-- filter / status -->
              <div class="col-auto">
                <lds-choice-group
                  identifier="taskStatus"
                  name="taskStatus"
                  [options]="taskStatusOptions"
                  [selected]="[selectedTaskStatus]"
                  (getChange)="onChoiceChange($event)">
                </lds-choice-group>
              </div>

              <!-- filter / tracking -->
              <ng-container *ngIf="isInProgressView">
                <div class="col-auto">
                  <lds-choice-group
                    identifier="taskTracking"
                    name="taskTracking"
                    [options]="taskTrackingOptions"
                    [selected]="selectedTaskTracking"
                    type="multiple"
                    (getChange)="onTrackingChoiceChange($event)">
                  </lds-choice-group>
                </div>
              </ng-container>

              <!-- search -->
              <div class="col">
                <lds-input
                  formControlName="searchText"
                  identifier="taskSearch"
                  name="taskSearch"
                  placeholder="search tasks"
                  iconPrefix="search">
                </lds-input>
              </div>

              <!-- filter / tag -->
              <div class="col-auto align-self-center">
                <lds-select
                  formControlName="tagFilter"
                  identifier="taskTagFilter"
                  name="taskTagFilter"
                  placeholder="All Tags"
                  [options]="tagOptions | ldsSelectOption"
                  [config]="{
                    valueProperty: 'value',
                    labelProperty: 'label'
                  }"
                  class="task-tag-filter">
                </lds-select>
              </div>

              <!-- mine only -->
              <div class="col-auto align-self-center">
                <lds-form-field margin="none">
                  <lds-toggle
                    formControlName="owned"
                    identifier="owned"
                    name="owned"
                    label="Mine only"
                    labelPosition="before"
                    (getChange)="onToggle($event)">
                  </lds-toggle>
                </lds-form-field>
              </div>
            </div>
          </form>
        </div>

        <!-- list of tasks -->
        <div class="tasks__list">
          <ng-template
            [ngTemplateOutlet]="tplTasksList"
            [ngTemplateOutletContext]="{
              tasks:
                tasks
                | taskFilterBy
                  : {
                      taskStatus: selectedTaskStatus,
                      searchText: form.value.searchText,
                      tracking: selectedTaskTracking,
                      tagFilterName: tagFilterName
                    }
                | taskSort
            }">
          </ng-template>
          <ng-template #tplTasksList let-tasks="tasks">
            <ng-container *ngIf="tasks.length; else tplNoResults">
              <ng-container *ngFor="let task of tasks">
                <div class="task">
                  <spark-summary-card
                    [isClickable]="true"
                    [link]="task | taskNavigationUrl">
                    <!-- task / status -->
                    <summary-card-icon>
                      <span
                        class="task__status task__status--{{
                          task.due | taskTrackingStatus
                        }}">
                        <lds-icon
                          name="circle"
                          size="xs"
                          variation="solid"
                          appearance="inherit">
                        </lds-icon>
                      </span>
                    </summary-card-icon>

                    <!-- task / details -->
                    <summary-card-header>
                      <div class="row align-items-center">
                        <div class="col-12 col-sm-4">
                          <div class="summary-card__title truncate">
                            {{ task.title }}
                          </div>
                          <div class="truncate">{{ task.entityName }}</div>
                        </div>

                        <!-- task / tags -->
                        <div class="col-12 col-sm-4">
                          <div class="entity-tags" *ngIf="task.tags?.length">
                            <span class="entity-tag-pill" *ngFor="let tagName of task.tags">
                              {{ tagName }}
                            </span>
                          </div>
                        </div>

                        <div class="col-12 col-sm-2">
                          <div>
                            <lds-icon
                              name="calendar"
                              size="xs"
                              appearance="inherit">
                            </lds-icon>
                            <span class="ml-xs">
                              {{ task.due | taskDueDate | date: 'dd/MM/yyyy' }}
                            </span>
                          </div>
                          <ng-container *ngIf="assignableUsers.length">
                            <div class="truncate">
                              <lds-icon
                                name="user"
                                size="xs"
                                appearance="inherit"
                                *ngIf="
                                  task.portfolio | adviserName: assignableUsers
                                ">
                              </lds-icon>
                              <span class="ml-xs">
                                {{
                                  task.portfolio | adviserName: assignableUsers
                                }}
                              </span>
                            </div>
                          </ng-container>
                        </div>

                        <!-- task / priority -->
                        <div class="col-12 col-sm-2">
                          <div class="text-nowrap" *ngIf="task.priority | taskHasAssignedPriority">
                            <lds-icon
                              name="flag"
                              size="xs"
                              appearance="inherit">
                            </lds-icon>
                            <span class="ml-xs">
                              {{ task.priority | taskUrgency }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </summary-card-header>

                    <!-- card / action -->
                    <summary-card-actions>
                      <lds-icon
                        summary-card-action
                        name="arrow-right"
                        appearance="inherit">
                      </lds-icon>
                    </summary-card-actions>
                  </spark-summary-card>
                </div>
              </ng-container>
            </ng-container>
          </ng-template>

          <!-- tpl / no results -->
          <ng-template #tplNoResults>
            <!-- no tasks -->
            <ng-container *ngIf="isDefaultFilter; else tplNoResultsForFilter">
              <lds-empty-state
                heading="No tasks found"
                message="Looks like you haven't added any tasks just yet. To get started, add a task to any contact, lead or opportunity.">
              </lds-empty-state>
            </ng-container>

            <!-- search and/or filters -->
            <ng-template #tplNoResultsForFilter>
              <lds-empty-state
                heading="No matching results found"
                message="You may want to try refining your search keywords or adjusting your filters.">
              </lds-empty-state>
            </ng-template>
          </ng-template>
        </div>
      </div>
    </ng-container>

  </layout-content>
</spark-layout>
